import { Component, OnInit } from '@angular/core';
import { SystemConfig } from '../../shared/config/system-config';
import { SessionService } from '../../shared/services/session/session.service';
import { Router } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';

@Component({
  selector: 'vit-logout-confirmation',
  templateUrl: './logout-confirmation.component.html',
  styleUrls: ['./logout-confirmation.component.scss']
})
export class LogoutConfirmationComponent implements OnInit {

  constructor(public sessionService: SessionService,
              public router: Router,
              public http: Http) {
  }

  ngOnInit() {
  }

  confirm() {
    this.http.post(SystemConfig.Endpoint.LOGOUT, {
      headers: new Headers()
    }).subscribe((response: Response) => this.handleLogoutResponse(),
        (error: Error) => this.handleLogoutResponse());
  }

  handleLogoutResponse() {
    this.sessionService.logout();
    this.router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/logout-confirmation/logout-confirmation.component.ts